import { msalInstance } from '../config/msalConfig'

export default function AccessDenied() {
  const account = msalInstance.getAllAccounts()[0]
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="card p-8 max-w-md text-center">
        <div className="w-14 h-14 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-4">
          <svg className="w-7 h-7 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
              d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
          </svg>
        </div>
        <h1 className="text-lg font-semibold text-text-primary">Access restricted</h1>
        <p className="text-sm text-text-muted mt-2">
          Your account isn't authorized to use the BOLDSecOps portal. Access is limited to members of
          the authorized security group. Please contact your administrator to request access.
        </p>
        {account?.username && (
          <p className="text-xs text-text-muted mt-3">
            Signed in as <span className="font-mono text-text-primary">{account.username}</span>
          </p>
        )}
        <button
          className="btn-secondary mt-6"
          onClick={() => msalInstance.logoutRedirect()}
        >
          Sign out / switch account
        </button>
      </div>
    </div>
  )
}
